import React, { useState } from 'react';
import ContactCTA from '../components/ContactCTA';
import './Reservation.css';

function Reservation() {
  const [formData, setFormData] = useState({
    groomName: '',
    brideName: '',
    phone: '',
    dates: '',
    time: '',
    guestCount: '',
    vendors: [],
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const vendorOptions = [
    '케이터링', '플라워 데코', '사진/영상 촬영', '식전 상영 영상 제작', '전문 사회자', '웨딩 헬퍼'
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleVendorChange = (vendor) => {
    setFormData(prev => ({
      ...prev,
      vendors: prev.vendors.includes(vendor)
        ? prev.vendors.filter(v => v !== vendor)
        : [...prev.vendors, vendor]
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await fetch('/.netlify/functions/submit-reservation', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ...formData,
          vendors: formData.vendors.join(', ')
        })
      });

      if (response.ok) {
        setSubmitted(true);
      } else {
        setError('제출 중 오류가 발생했습니다. 다시 시도해주세요.');
      }
    } catch (err) {
      setError('네트워크 오류가 발생했습니다. 다시 시도해주세요.');
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div className="reservation-page">
        <section className="reservation-success">
          <div className="container">
            <div className="success-content fade-in">
              <h1>신청이 완료되었습니다</h1>
              <p>Garden Poète에서 곧 연락드리겠습니다.</p>
              <p className="success-note">보통 1-2 영업일 내에 답변드립니다.</p>
            </div>
          </div>
        </section>
      </div>
    );
  }

  return (
    <div className="reservation-page">
      <section className="reservation-hero">
        <div className="container">
          <div className="hero-content fade-in">
            <h1 className="page-hero-title">RESERVATION</h1>
            <p className="hero-subtitle">Request a Reservation</p>
          </div>
        </div>
      </section>

      <section className="reservation-form-section">
        <div className="container">
          <div className="form-content fade-in">
            <p className="form-desc">아래 양식을 작성해 주시면 Garden Poète에서 확인 후 연락드리겠습니다.</p>
            <form onSubmit={handleSubmit} className="reservation-form">
              <div className="form-row">
                <div className="form-group">
                  <label>신랑 성함 *</label>
                  <input type="text" name="groomName" value={formData.groomName} onChange={handleChange} required placeholder="신랑 성함" />
                </div>
                <div className="form-group">
                  <label>신부 성함 *</label>
                  <input type="text" name="brideName" value={formData.brideName} onChange={handleChange} required placeholder="신부 성함" />
                </div>
              </div>

              <div className="form-group">
                <label>대표 연락처 *</label>
                <input type="tel" name="phone" value={formData.phone} onChange={handleChange} required placeholder="010-0000-0000" />
              </div>

              <div className="form-group">
                <label>예식 희망 날짜 *</label>
                <input type="text" name="dates" value={formData.dates} onChange={handleChange} required placeholder="예: 2025년 6월 7일, 2025년 6월 14일 (복수 기입 가능)" />
              </div>

              <div className="form-group">
                <label>예식 시간 *</label>
                <div className="radio-group">
                  <label className="radio-label">
                    <input type="radio" name="time" value="10:00 ~ 14:30 (오전)" onChange={handleChange} required />
                    <span>10:00 ~ 14:30 (오전)</span>
                  </label>
                  <label className="radio-label">
                    <input type="radio" name="time" value="17:30 ~ 22:00 (오후)" onChange={handleChange} />
                    <span>17:30 ~ 22:00 (오후)</span>
                  </label>
                  <label className="radio-label">
                    <input type="radio" name="time" value="13:00 ~ 20:00 (올데이)" onChange={handleChange} />
                    <span>13:00 ~ 20:00 (올데이)</span>
                  </label>
                </div>
              </div>

              <div className="form-group">
                <label>예상 하객 수 *</label>
                <input type="number" name="guestCount" value={formData.guestCount} onChange={handleChange} required placeholder="예: 80" min="70" max="200" />
              </div>

              <div className="form-group">
                <label>제휴업체 상담 희망 (복수 선택 가능)</label>
                <div className="checkbox-group">
                  {vendorOptions.map(vendor => (
                    <label key={vendor} className="checkbox-label">
                      <input
                        type="checkbox"
                        checked={formData.vendors.includes(vendor)}
                        onChange={() => handleVendorChange(vendor)}
                      />
                      <span>{vendor}</span>
                    </label>
                  ))}
                </div>
              </div>

              <div className="form-group">
                <label>기타 문의사항</label>
                <textarea name="message" value={formData.message} onChange={handleChange} placeholder="궁금하신 점이나 요청사항을 자유롭게 적어주세요." rows="5" />
              </div>

              {error && <p className="error-message">{error}</p>}

              <button type="submit" className="btn-submit" disabled={loading}>
                {loading ? '제출 중...' : '예약 신청하기'}
              </button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Reservation;
